package com.klantenstop.web.data.service

import com.klantenstop.web.data.NetworkingConfig
import com.klantenstop.web.data.getRequest
import com.klantenstop.web.data.models.NetworkResponse
import com.klantenstop.web.data.models.dto.responses.ErrorResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

interface CityService {
    suspend fun autocomplete(query: String): List<CitySuggestion>
}

object NominatimCityService : CityService {
    private val baseUrl = "${NetworkingConfig.baseUrl}/api/v1/city-suggestion"

    override suspend fun autocomplete(query: String): List<CitySuggestion> {
        val url = "$baseUrl?query=${encodeURIComponent(query)}"

        val response: NetworkResponse<List<CitySuggestion>, ErrorResponse> = getRequest(url)

        return when (response) {
            is NetworkResponse.Success -> response.body
            else -> emptyList()
        }
    }

    private fun encodeURIComponent(str: String): String {
        return js("encodeURIComponent(str)") as String
    }
}

@Serializable
data class CitySuggestion(
    val id: Int,
    val name: String,
    @SerialName("display_name")
    val displayName: String,
    val latitude: Double,
    val longitude: Double
)
